/* eslint-disable */
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
import Echo from 'laravel-echo';

window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.userType = require('./Composables/Enums/userType');

window.clinicianRole = require('./Composables/Enums/clinicianRole');

//  import socket-io client and make it available to the global window
window.io = require('socket.io-client-v2');

if (typeof window.io !== 'undefined') {
  window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: window.location.hostname,
    path: process.env.MIX_LARAVEL_ECHO_SERVER_PATH,
    transports: ['websocket', 'polling', 'flashsocket']
  });
}

// Initialize Jitsi Meet if JitsiMeet is imported (if we're in the session view)
if (window.JitsiMeetJS) {
  JitsiMeetJS.init();
  // TODO: #STREAMING - looks like ERROR level isn't enough to see the problem with the streaming
  JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.ERROR);
}

document.cookie = `timezone = ${Intl.DateTimeFormat().resolvedOptions().timeZone}`;
